import styles from './ContactSupportAI.module.scss';
import ContactSupportHeader from './contact-support-header/ContactSupportHeader';
import clsx from 'clsx';
import QueryContainer from './query-container/QueryContainer';
import AiResponseContainer from './ai-response-container/AiResponseContainer';
import AiResponseContainerLoader from './ai-response-container/AiResponseContainerloader';
import SupportOptionsContainer from './support-options-container/SupportOptionsContainer';
import { useContactSupportAI } from '../hooks/useContactSupportAI';

export default function ContactSupportAI({ onClose }: { onClose: () => void }) {
  const {
    data,
    error,
    loaderTitle,
    maximized,
    onBack,
    onCloseClick,
    onCreateConversation,
    onGetSolution,
    onMaximize,
    onMinimize,
    onOpenSupportChatClick,
    onRaiseTicket,
    onResolveIssueClick,
    openSupportOptions,
    queryType,
    showContactSupportOptions,
    showConversationLoader,
    showQueryContainer,
    showReportIssueContainer,
    supportUnreadCount,
    uiState
  } = useContactSupportAI({ onClose });

  return (
    <>
      <div
        data-id='contact-support'
        className={clsx(styles.contactSupportContainer, maximized && styles.maximized)}
      >
        <ContactSupportHeader
          hideBackButton={showQueryContainer}
          badgeContent={supportUnreadCount}
          openSupportChat={() => {
            onOpenSupportChatClick();
          }}
          onClose={() => {
            onCloseClick();
          }}
          maximized={maximized}
          onBack={() => {
            onBack();
          }}
          onMaximize={onMaximize}
          onMinimize={onMinimize}
        />
        {showQueryContainer && !showConversationLoader ? (
          <div className={clsx('d-flex h-100')}>
            <QueryContainer onGetSolution={onGetSolution} />
          </div>
        ) : null}

        {showConversationLoader  && (
          <AiResponseContainerLoader

            title={loaderTitle}
          />
        )}

        {showContactSupportOptions && !showConversationLoader && (
          <SupportOptionsContainer onCreateConversation={onCreateConversation} onRaiseTicket={onRaiseTicket} />
        )}

        

        {showReportIssueContainer && (
          <AiResponseContainer
            queryType={queryType}
            response={data}
            onTalkToSupport={openSupportOptions}
            onResolveIssue={onResolveIssueClick}
            uiState={uiState}
            error={error}
          />
        )}
      </div>
    </>
  );
}
